const BLEND_MODES = Object.freeze([
    "normal", "darken", "multiply", "color-burn", "lighten",
    "screen", "color-dodge", "overlay", "soft-light", "hard-light",
    "difference", "exclusion",
    "hue", "saturation", "color", "luminosity",
    "source-in", "source-out", "source-atop",
    "destination-over", "destination-in", "destination-out", "destination-atop",
    // PS specific blend modes
    "dissolve", "linear-burn", "linear-dodge", "darker-color", "lighter-color",
    "vivid-light", "linear-light", "pin-light", "hard-mix", "subtract", "divide"
]);

export {
    BLEND_MODES
};
